// export const CONFIRM_CHANGE_SKIN_MSG = "스킨을 변경하면 홈 커버, 사이드바, 일부 광고 설정이 초기화 될 수 있습니다. 적용하시겠습니까?";
export const CONFIRM_CHANGE_SKIN_MSG = "스킨을 변경하면 홈 커버, 사이드바 설정이 초기화 될 수 있습니다. 적용하시겠습니까?";
